module.exports = __webpack_public_path__ + "Mission_Header_new.f72fd9ac.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/desktop/headers/Mission_Header_new.png
// module id = BRuC
// module chunks = 0